import { promisify } from './async'

export function resolveProperty(fronthubInstance) {
  const { configuration = {}, manifestInstance = {} } = fronthubInstance
  return (prop, lazy = false) => {
    const property = configuration[prop] || {}
    if (lazy) {
      let promise
      return {
        then(func, err) {
          if (!promise) {
            promise = promisify(property, manifestInstance)
          }

          const ret = promise.then(
            success => !ret.canceled && func.call(void 0, success),
            err,
          )

          ret.cancel = () => (ret.canceled = true)

          return ret
        },
      }
    } else {
      return property
    }
  }
}
